import { JsxElement } from "@/utils/jsxElementTypes";
import { create } from "zustand";
import { persist } from "zustand/middleware";

interface AssetsPanelState {
  // Search state
  searchVal: string;

  // Tab state
  activeTab: string;

  // Accordion state
  searchAccordionValues: string[];

  // Component state
  variantSelected: any | null;
  detailedAsset: JsxElement | null;

  // Actions
  setSearchVal: (value: string) => void;
  setActiveTab: (value: string) => void;
  setSearchAccordionValues: (values: string[]) => void;
  setVariantSelected: (value: any | null) => void;
  setDetailedAsset: (asset: JsxElement | null) => void;
}

export const useAssetsPanelStore = create<AssetsPanelState>()(
  persist(
    (set) => ({
      // Initial state
      searchVal: "",
      activeTab: "Storybook",
      searchAccordionValues: [],
      variantSelected: null,
      detailedAsset: null,

      // Actions
      setSearchVal: (value) => set({ searchVal: value }),
      setActiveTab: (value) => set({ activeTab: value }),
      setSearchAccordionValues: (values) =>
        set({ searchAccordionValues: values }),
      setVariantSelected: (value) => set({ variantSelected: value }),
      setDetailedAsset: (asset) => set({ detailedAsset: asset }),
    }),
    {
      name: "assets-panel-storage",
    }
  )
);
